<template>
  <div>
    <el-table
      v-if="showTable"
      :data="namelistScore"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :index="(index) => indexMethod(index, page, pageSize)"
        :width="
          widthMax < 767.98
            ? '60'
            : widthMax < 1199
            ? '60'
            : widthMax > 1200
            ? '80'
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="nameTH"
        label="ชื่อ"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '120' : widthMax < 1199 ? '120' : ''"
      ></el-table-column>
      <el-table-column
        prop="surnameTH"
        label="นามสกุล"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '120' : widthMax < 1199 ? '120' : ''"
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="ชื่อบริษัท"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '120' : widthMax < 1199 ? '120' : ''"
      ></el-table-column>
      <el-table-column
        prop="mobilephone"
        label="เบอร์โทรศัพท์"
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '130'
            : widthMax > 1199.98
            ? ''
            : ''
        "
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="email"
        label="อีเมล"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '130'
            : widthMax > 1199.98
            ? ''
            : ''
        "
        sortable
      ></el-table-column>
      <el-table-column
        prop="successDate"
        label="วันที่และเวลาที่จบหลักสูตร"
        :width="
          widthMax < 767.98
            ? '200'
            : widthMax < 991.98
            ? ''
            : widthMax < 1150
            ? '200'
            : widthMax > 1199.98
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">{{
          scope.row.successDate | dateTimeTh
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="showAction"
        label
        width="80"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <div
                @click="
                  $router.push(
                    `/manage/activity/subject/list?edit=false&courseId=${courseId}&userId=${scope.row._id}`
                  )
                "
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-eye"></i>
              </div>
            </div>
            <div  v-if="user && user.role != 50" class="box-action">
              <div
                @click="printCertificate(scope.row.nameTH,scope.row.surnameTH, scope.row.successDate)"
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-print"></i>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
export default {
  props: {
    showAction: {
      type: Boolean,
      default() {
        return true;
      },
    },
    namelistScore: {
      type: Array,
      default() {
        return [];
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    dateLabel: {
      type: String,
      default() {
        return "วันที่และเวลาที่อัปเดต";
      },
    },
    dateObj: {
      type: String,
      default() {
        return "updatedAt";
      },
    },
    pageSize:{
      type:Number,
      default(){
        return 0
      }
    },
    page:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  computed: {
    user(){
      return this.$store.state.user
    }
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    printCertificate(nameTH,surnameTH,successDate) {
      this.$emit("printCertificate", nameTH,surnameTH,successDate);
    },
  },
};
</script>